import { inject, NgModule, provideAppInitializer }                      from '@angular/core';
import { CommonModule }                                                 from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { map }                  from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { ErrorHandlingModule }  from './error-handling/error-handling.module';
import { AuthModule }           from './auth/auth.module';
import { IframeService }        from './iframe.service';
import { JsVariableStorage }    from './auth/token-storage/js-variable-storage';
import { CookieStorage }        from './auth/token-storage/cookie-storage';
import { TokenStorage }         from './auth/token-storage/token-storage';
import { environment }          from '../../environments/environment';

const TOKEN_STORAGE_LIFESPAN = environment.sessionExpirationTime + environment.sessionExpirationExtraTime;

@NgModule({
  declarations: [],
  exports: [],
  imports: [AuthModule, CommonModule, ErrorHandlingModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((configService: ConfigurationService, iframeService: IframeService) => () => configService
        .init()
        .pipe(map(() => iframeService.init())))(inject(ConfigurationService), inject(IframeService));
      return initializerFn();
    }),
    {
      provide: TokenStorage,
      useValue: IframeService.runsInIframe()
        ? new JsVariableStorage(TOKEN_STORAGE_LIFESPAN)
        : new CookieStorage(TOKEN_STORAGE_LIFESPAN)
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule {
}